import { Component, OnInit, ChangeDetectionStrategy, ViewChild, Input, TemplateRef, Output, EventEmitter, Injector, OnDestroy, Directive } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { MatSelectionList, MatSelectionListChange } from '@angular/material/list';
import { BehaviorSubject, Subscription } from 'rxjs';
import { MxCrudCreateConfig, MxCrudCreateConfig as MxCrudAddConfig, MxCrudPanelColumns } from '../../mx-crud-panel.model';
import { distinctUntilChanged, tap } from 'rxjs/operators';
import { MxCrudService } from '../../mx-crud-panel.service';

@Directive({
  selector: 'mx-add-panel, [mx-add-panel], [mxAddPanel]',
  host: {'class': 'mx-add-panel'},
})
export class MxAddPanel {}

@Component({
  selector: 'mx-crud-panel',
  templateUrl: './mx-crud-panel.component.html',
  styleUrls: ['../../styles/mx-crud-panel.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
  exportAs:"mxCrudPanel"
})
export class MxCrudPanel implements OnInit, OnDestroy {

  itemSelected: any
  List: any[] = []

  /** Iterable que será leído en la tabla */
  public _list = new BehaviorSubject<any[]>([]);
  @Input() set list( list: any[] ) { this._list.next( list  ); }
  get list() { return this._list.getValue()}

  @Input() listName: string = ''

  #addConfig: MxCrudCreateConfig = {}
  @Input() set addBtnConfig( config: MxCrudCreateConfig ) {
    this.#addConfig = {
      label: config.label || 'Nuevo',
      color: config.color || 'accent',
      icon: config.icon || 'add',
      enableIcon: config.enableIcon ||  true
    }
  }
  get addBtnConfig() { return this.#addConfig }



  @Input() itemSelector: string = ''
  @Input() columns?: (string | MxCrudPanelColumns)[]
  public colRefs: string[] = []

  @Input() selectTemplate: TemplateRef<any> = {} as TemplateRef<any>
  @Input() addTemplate: TemplateRef<any> = {} as TemplateRef<any>
  addSwitched: boolean = false

  @Input() height_vh: any
  @Input() width_vw: any = 80
  @Input() backdrop: boolean = true
  @Input() panelPosition: MatDrawer[ 'position' ] = 'end'
  @Input() loadingAnimation: boolean = true
  @Input() emptyMessage?: string

  private injectData?: Injector
  itemCtx: any
  // @ContentChild()

  @ViewChild( 'itemPanel' ) public itemPanel?: MatDrawer
  @ViewChild( 'listPanel' ) public listPanel?: MatSelectionList
  // @ViewChild( 'addItem' ) public addItemPanel?: MatDrawer

  @Output() onDelete = new EventEmitter<any>()
  @Output() onAdd = new EventEmitter<void>()
  @Output() onClose = new EventEmitter<void>()
  @Output() onSelect = new EventEmitter<any>()

  // @Output() onAdd: EventEmitter<any> = new EventEmitter()
  // @Output() onSave: EventEmitter<any> = new EventEmitter()

  private listSubscription!: Subscription

  constructor (
    private _crud: MxCrudService
  ) {
  }

  ngOnInit(): void {
    if (!this.columns) this.columns = [this.itemSelector]
    this.colRefs = [ ...this.columns.map((c) => typeof c == 'string' ? c : c.id), 'options']

    this.listSubscription = this._list.pipe(
      distinctUntilChanged( ( x: any, y: any ) => JSON.stringify( x ) === JSON.stringify( y ) ),
    ).subscribe();

  }

  colId(col: string | MxCrudPanelColumns) {
    return typeof col == 'string' ? col : col.id
  }

  colDisplay( col: string | MxCrudPanelColumns ) {
    return typeof col == 'string' ? col : col.displayName
  }

  colValue( item: any, col: string | MxCrudPanelColumns ) {
    let param = this.colId( col )
    let [key, subkey] = param.split( '.' )

    return subkey ? item[key][subkey] : item[ param ]
  }

  colValueType( value: any ) {
    if ( typeof value === 'object' ) {
      if ( 'seconds' in value ) return 'timestamp'
    }
    return typeof value
  }

  openItemPanel( selected?: any ) {
    if ( this.itemPanel!.opened ) { this.itemPanel!.close() }

    if ( selected ) {
      this.itemSelected = selected
      this.itemCtx = {item: this.itemSelected}
    } else {
      this.addSwitched = true
      this.onAdd.emit()
    }

    this.itemPanel!.open()

  }

  closeItemPanel() {
    this.itemPanel?.close()
    this.listPanel?.deselectAll()
    this.addSwitched = false
    this.itemSelected = undefined
    this.onClose.emit()
    this._crud.onClosed.next()
  }

  onDeleteItem(item: any) {
    this.onDelete.emit(item as typeof item)
  }

  ngOnDestroy() {
    this.listSubscription.unsubscribe()
  }


}
